import { PLANIFICATION_STATUS, REQUEST_PASS_STATUS } from '../../constants/enum';
import PlanificationStatusRenderer from '../Planification/PlanificationStatusRenderer';
import moment from 'moment/moment';
import React, { useEffect } from 'react';
import { faTrashAlt, faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const style = {
  blue: {
    backgroundColor: '#02ADFF',
  },
  yellow: {
    backgroundColor: '#FFFF00',
  },
  orange: {
    backgroundColor: '#FFC000',
  },
  purple: {
    backgroundColor: '#7030A0',
  },
  burgundy: {
    backgroundColor: '#C00000',
  },
  lightPurple: {
    backgroundColor: '#7987FF',
  },
  pink: {
    backgroundColor: '#FFCCFF',
  },
  green: {
    backgroundColor: '#00B050',
  },
  grey: {
    backgroundColor: '#A6A6A6',
  }
}

const StatusRenderer = (props) => {
  const { status, askType } = props;

  switch (status) {
    case PLANIFICATION_STATUS.NEW:
      if (askType === 'wanted') {
        return style.blue;
      } else if (askType === 'optional') {
        return style.yellow;
      }
      break;
    case PLANIFICATION_STATUS.ACCEPTED_PROVISIONAL:
      return style.orange;
    case PLANIFICATION_STATUS.CONFIRMED_CLIENT:
      return style.burgundy;
    case PLANIFICATION_STATUS.CONFIRMED_CENTERS:
      return style.pink;
    case PLANIFICATION_STATUS.ACCEPTED_CENTER:
      return style.purple;
    case PLANIFICATION_STATUS.AGREEMENT_ISSUED:
      return style.green;
    case PLANIFICATION_STATUS.PASSAGE_MADE:
      return style.green;
    case PLANIFICATION_STATUS.NOT_DONE:
      return style.grey;
    case PLANIFICATION_STATUS.CANCELLED:
      return style.grey;
    case PLANIFICATION_STATUS.REFUSED:
      return style.grey;
    default:
      return style.grey;
  }
}

const PlanificationEvent = (props) => {
  const { planification, eventInfo, centers } = props;
  const weight = (p) => p.metadata?.concernedPath?.full == true ? 1 : 0.5;

  const sorted = (planification.dossier?.planifications ?? [])
      .filter((p) => p.deleted === false)
      .sort((a, b) => a.id - b.id);

  let n = 0;
  for (const p of sorted) {
      n += weight(p);
      if (p.id === planification.id) break;
  }
  const currentPlanifIndex = n;

  const nbPlanification = planification.dossier
      ? (planification.dossier.metadata.datePassage.nbPassageAller ?? 0) + (planification.dossier.metadata.datePassage.nbPassageRetour ?? 0)
      : 0;

  let hasReturn = planification.dossier?.metadata?.trajetDescr.descrRetour.length > 1 || planification.dossier?.metadata?.trajetDescr.descrRetour[0].numeroSection !== null;

  return <div
        className={`event-main-container ${planification.type === PLANIFICATION_STATUS.UNAVAILABLE ? 'indisp' : null}`}
        style={planification.type === PLANIFICATION_STATUS.UNAVAILABLE ? null : StatusRenderer({ status: planification.metadata.status, askType: planification.metadata.askType })}
    >
    <div className={'event-time-container'}>
      <div className={'full-data-container'}>{eventInfo.timeText === '' ? 'Toute la journée' : eventInfo.timeText}</div>
    </div>
    <div className={'event-content-container'}>

      <div className={'full-data-container'} style={{ display: 'none' }}>
        {planification.type !== PLANIFICATION_STATUS.UNAVAILABLE &&
          <>
            <div className={'event-content-name'}>
             {planification.dossier?.incomplete && <FontAwesomeIcon icon={faWarning} style={{ color: '#ff0000', height: '16px' }} />} Dossier N° {planification.dossier_id}-{currentPlanifIndex}/{nbPlanification}
            </div>
            <div className={'event-content-status'}>
              <div className={'event-content-status-item'}>
                <PlanificationStatusRenderer
                  data={planification}
                  displayLabel={true}
                  displayIcon={false}
                />
              </div>
              <div className={'event-content-status-item'}>
                <span style={{ fontWeight: 'bold' }}>Date de création :&nbsp;</span>
                <span>{moment(planification.date_creation).format('DD/MM/YYYY à HH:mm')}</span>
              </div>
              <div className={'event-content-status-item'}>
                <span style={{ fontWeight: 'bold' }}>Transporteur :&nbsp;</span>
                <span>{planification.dossier.metadata.complementIdentite.transporteur}</span>
              </div>
              {(planification.metadata.concernedPath.aller.length > 0 || planification.metadata.concernedPath.retour.length > 0) &&
              <div className={'event-content-status-item'}>
                <span style={{ fontWeight: 'bold' }}>Tronçons actifs :&nbsp;</span>
                {planification.metadata.concernedPath.aller && planification.metadata.concernedPath.selectedPath === 'aller' && planification.metadata.concernedPath.aller.length > 0 ? <span>Aller : {planification.metadata.concernedPath.aller.map((path, i) => {
                  if (i === planification.metadata.concernedPath.aller.length - 1) {
                    return `${path.numeroSection} ${path.road}, ${path.nomSection ?? ''}`;
                  }
                  return `${path.numeroSection} ${path.road}, ${path.nomSection ?? ''} - `;
                })}</span> : null}
                {hasReturn && planification.metadata.concernedPath.selectedPath === 'retour' && planification.metadata.concernedPath.retour.length > 0 ?<span>Retour : {planification.metadata.concernedPath.retour.map((path, i) => {
                  if (i === planification.metadata.concernedPath.retour.length - 1) {
                    return `${path.numeroSection} ${path.road}, ${path.nomSection ?? ''}`;
                  }
                  return `${path.numeroSection} ${path.road}, ${path.nomSection ?? ''} - `;
                })}</span> : null}
              </div>
              }
              <div className={'event-content-status-item'}>
                <span style={{ fontWeight: 'bold' }}>Centres :&nbsp;</span>
                <span>
                      {
                        planification.metadata.centers.map((hub, i) => {
                          let center = null;

                          centers.map((aCenterList) => {
                            if (Number(aCenterList.id) === Number(hub.id)) {
                              center = aCenterList;
                            }
                          });

                          if (center) {
                            if ((i + 1) !== planification.metadata.centers.length) {
                              return center.label + ', ';
                            }
                            return center.label;
                          }
                        })
                      }
                    </span>
              </div>
            </div>
          </>
        }
        {planification.type === PLANIFICATION_STATUS.UNAVAILABLE &&
          <>
            <div className={'event-content-name'}>
              Indisponibilité
            </div>
            <div className={'event-content-status'}>
              <span style={{ fontWeight: 'bold' }}>Centres :&nbsp;</span>
              <span>
                      {
                        planification.metadata.centers?.map((hub, i) => {
                          let center = null;

                          centers.map((aCenterList) => {
                            if (Number(aCenterList.id) === Number(hub.id)) {
                              center = aCenterList;
                            }
                          });

                          if (center) {
                            if ((i + 1) !== planification.metadata.centers.length) {
                              return center.label + ', ';
                            }
                            return center.label;
                          }
                        })
                      }
              </span>
              <br /><br />
              <span style={{ fontWeight: 'bold' }}>Motif :&nbsp;</span>
              <span>
                {planification.metadata.comment}
              </span>
            </div>
          </>
        }
      </div>

      <div className={'redux-data-container'} style={{ display: 'block' }}>
        {planification.type !== PLANIFICATION_STATUS.UNAVAILABLE &&
          <>
            <div className={'event-content-name'}>
              {planification.dossier?.status.id < REQUEST_PASS_STATUS.BLOCKED && <FontAwesomeIcon icon={faWarning} style={{ color: '#ff0000', height: '16px' }} />} N° {planification.dossier_id}-{currentPlanifIndex}/{nbPlanification}
            </div>
            <div className={'event-content-status'}>
              <div>
                <PlanificationStatusRenderer
                  data={planification}
                  displayLabel={false}
                />
              </div>
              <p>
                {planification.dossier.metadata.complementIdentite.transporteur}
              </p>
            </div>
          </>
        }

        {planification.type === PLANIFICATION_STATUS.UNAVAILABLE &&
          <>
            <div className={'event-content-name'}>
              Indisp.
            </div>
            <div className={'event-content-status'}>
              <span style={{ fontWeight: 'bold' }}>Centres :&nbsp;</span>
              <span>
                      {
                        planification.metadata.centers?.map((hub, i) => {
                          let center = null;

                          centers.map((aCenterList) => {
                            if (Number(aCenterList.id) === Number(hub.id)) {
                              center = aCenterList;
                            }
                          });

                          if (center) {
                            if ((i + 1) !== planification.metadata.centers.length) {
                              return center.label + ', ';
                            }
                            return center.label;
                          }
                        })
                      }
              </span>
              <br /><br />
              <span style={{ fontWeight: 'bold' }}>Motif :&nbsp;</span>
              <span>
                {planification.metadata.comment}
              </span>
            </div>
          </>
        }
      </div>

    </div>
  </div>;
};

export default PlanificationEvent;
